export default __webpack_public_path__ + "static/media/termite-resistant.a34a357e.svg";